var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuasiReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0516 5.5C15.3278 5.5 15.5516 5.27614 15.5516 5C15.5516 4.72386 15.3278 4.5 15.0516 4.5V5.5ZM15.0516 4.5H6.21873V5.5H15.0516V4.5ZM4.54102 6V13H5.54102V6H4.54102ZM6.21873 14.5H15.4327V13.5H6.21873V14.5ZM4.54102 13C4.54102 13.902 5.37197 14.5 6.21873 14.5V13.5C5.76463 13.5 5.54102 13.2026 5.54102 13H4.54102ZM6.21873 4.5C5.37197 4.5 4.54102 5.09801 4.54102 6H5.54102C5.54102 5.79742 5.76463 5.5 6.21873 5.5V4.5Z",
    fill: "#00ABFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 11.5L15.0575 13.6397C15.2619 13.8364 15.2619 14.1636 15.0575 14.3603L12.834 16.5",
    stroke: "#00ABFB",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2384 7.5C9.4066 7.5 8.69922 8.15364 8.69922 9V12.5001L9.69922 12.5001V9C9.69922 8.74179 9.92233 8.5 10.2384 8.5H16.4734C16.7894 8.5 17.0125 8.74179 17.0125 9V18C17.0125 18.2582 16.7894 18.5 16.4734 18.5H10.2384C9.92233 18.5 9.69922 18.2582 9.69922 18V15.5001L8.69922 15.5001V18C8.69922 18.8464 9.4066 19.5 10.2384 19.5H16.4734C17.3051 19.5 18.0125 18.8464 18.0125 18V9C18.0125 8.15364 17.3051 7.5 16.4734 7.5H10.2384ZM8.69922 14.5001L9.69922 14.5001V13.5001L8.69922 13.5001V14.5001Z",
    fill: "#00ABFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuasiReplace);
export default __webpack_public_path__ + "static/media/quasiReplace.ac274d897dc2bc7777b5326458364134.svg";
export { ForwardRef as ReactComponent };